import {shallowEqual, useSelector} from "react-redux";
import * as c from "../../../constants";
import {createSelector} from "@reduxjs/toolkit";

// Selector to get all associated entity IDs (children, parent, grandparent)
const selectAssociatedEntityIds = createSelector(
    [(state) => state.orgTree.entities, (_, entityId) => entityId],
    (entities, entityId) => {
        if (!entityId || !entities[entityId]) return [];

        const associatedIds = [entityId]; // Include the selected entity

        // Add children recursively
        const addChildrenIds = (parentId) => {
            Object.values(entities).forEach(entity => {
                if (entity.parententityid === parentId) {
                    associatedIds.push(entity.entityid);
                    addChildrenIds(entity.entityid);
                }
            });
        };

        // Add parent and grandparent
        const addParentIds = (childId) => {
            const entity = entities[childId];
            if (entity && entity.parententityid) {
                associatedIds.push(entity.parententityid);
                addParentIds(entity.parententityid); // Recursive call
            }
        };

        addChildrenIds(entityId);
        addParentIds(entityId);
        return [...new Set(associatedIds)]; // Remove duplicates
    }
);

export const useSidePanelExpansion = (entitySelected) => {


    // Get all associated entity IDs
    const associatedEntityIds = useSelector(
        (state) => selectAssociatedEntityIds(state, entitySelected),
        shallowEqual
    );

    const {
        defaultExpanded,
        defaultSelected
    } = useSelector((state) => {
        let entitiesToExpand = [];
        const contextID = state.coreEntities.ContextID;

        const defaultSelectedEntity = state.coreEntities.entities[contextID].entityid;

        state.coreEntities.ids.forEach((id) => {
            const entity = state.coreEntities.entities[id];
            if (entity && entity.typeid !== c.ENTITY_TYPE.Device && entity.context) {
                entitiesToExpand.push(entity.entityid);
            }
        })

        return {
            defaultExpanded: entitiesToExpand,
            defaultSelected: defaultSelectedEntity
        }
    }, (one, two) => JSON.stringify(one) === JSON.stringify(two));

    return {
        defaultExpanded,
        defaultSelected,
        entitiesSelectedExpanded: [...defaultExpanded, ...associatedEntityIds]
    }
};